module.exports = __webpack_public_path__ + "static/media/YM89_5.d8bba72b.jpg";